import React from "react";
import {Button, Form, Modal, Table} from "react-bootstrap";

import { withTranslation } from "react-i18next";
import APIErrorHelper from "../../../../../../helpers/APIErrorHelper";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import ConfirmationDialog from "../../../../../../components/dialogs/confirmationDialog/ConfirmationDialog";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import BaseSelect from "../../../../../../components/baseSelect/BaseSelect";

class ManageReplacementDevices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        replacementDevices: [],
        options: [],
        selectedDevice: null,
        assignedDevice: null,
        showConfirmationDialog: false,
        dialogApiError: ""
    };

    this.handleAssign = this.handleAssign.bind(this);
    this.handleFree = this.handleFree.bind(this);
    this.loadData   = this.loadData.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.instance && prevProps.instance === null){
          this.loadData();
      }
  }

  async loadData(){
      const replacementDevices = await CamplaCoreService.getAllReplacementDevices();
      let assigned = null;
      const devices = [];
      for (const device of replacementDevices){
        if (device.authenticatorId === this.props.instance.memberId){
            assigned = device;
        }else if(device.authenticatorId === null){
            devices.push(device);
        }
      }
      const options = devices.map(dev => {
          return {
              value: dev, label: `${dev.identifier}`
          }
      });
      this.setState({
          selectedDevice: options.length > 0 ? options[0] : null,
          options: options,
          assignedDevice: assigned,
          replacementDevices: devices
      });
  }

  async handleAssign(memberDevice) {
    try {
        await CamplaCoreService.assignReplacementDevice({
            id: memberDevice.id,
            instanceId: this.props.instance._id
        });
        await this.loadData();
        this.setState({showConfirmationDialog: false})
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  async handleFree() {
    try {
        await CamplaCoreService.freeReplacementDevice(this.props.instance._id);
        await this.loadData();
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }


  render() {
    const { t } = this.props;

    return (
      <>
        <ConfirmationDialog
          title={t(
            "SingleExamination.InstanceTab.ReplacementDeviceDialog.ConfirmTitle"
          )}
          body={t(
            "SingleExamination.InstanceTab.ReplacementDeviceDialog.ConfirmQuestion"
          )}
          show={this.state.showConfirmationDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: "",
              showConfirmationDialog: false
            })
          }
          onSubmit={() => this.handleAssign(this.state.assignedDevice)}
          confirmButtonVariant="green"
          confirmButtonText={t("SingleExamination.InstanceTab.ReplacementDeviceDialog.ButtonAssign")}
          cancelButtonVariant="black"
        />
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("SingleExamination.InstanceTab.ReplacementDeviceDialog.Title")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              {this.state.dialogApiError}
              {this.state.assignedDevice ?
                  (
                      <Table size="sm">
                          <thead>
                          <tr>
                              <th>{t("SingleExamination.InstanceTab.ReplacementDeviceDialog.ColumnIdentifier")}</th>
                              <th>{t("SingleExamination.InstanceTab.ReplacementDeviceDialog.ColumnModel")}</th>
                              <th>{t("SingleExamination.InstanceTab.ReplacementDeviceDialog.ColumnSerial")}</th>
                              <th></th>
                          </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>{this.state.assignedDevice.identifier}</td>
                                  <td>{this.state.assignedDevice.name}</td>
                                  <td>{this.state.assignedDevice.serial}</td>
                                  <td>
                                      <Button
                                          onClick={() => this.handleFree()}
                                          className="btn btn-red btn-sm">
                                          <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                  </td>
                              </tr>
                          </tbody>
                      </Table>) :
                  <>
                      <p>
                        <b>{t("SingleExamination.InstanceTab.ReplacementDeviceDialog.NoDevice")}</b>
                      </p>
                      <Form.Group controlId="formReplacementDevice">
                          <Form.Label>
                              {t(
                                  "SingleExamination.InstanceTab.ReplacementDeviceDialog.SelectDevice"
                              )}
                          </Form.Label>
                          <BaseSelect
                              options={this.state.options}
                              onChange={s => this.setState({selectedDevice: s})}
                              value={this.state.selectedDevice}
                          />
                      </Form.Group>
                  <Button
                      onClick={() => this.setState({
                          showConfirmationDialog: true,
                          assignedDevice: this.state.selectedDevice.value
                      })}
                      className="btn btn-green">
                      {t("SingleExamination.InstanceTab.ReplacementDeviceDialog.ButtonAssign")}
                  </Button>
                  </>}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default withTranslation()(ManageReplacementDevices);
